import Loader from 'components/Loader'
import { useGetBaskets } from 'hooks/specsBasketManagement'
import React from 'react'
import { useAppSelector } from 'redux/hook'
import { getVolumesUserState } from 'redux/volumes/volumesSlice'
import { MyPageSpecsBasketsGrid } from '../MyPageSpecsBasketsGrid'
import { StyledMyPageBasketsSharedToYou } from './MyPageBasketsSharedToYou.styles'

export const MyPageBasketsSharedToYou: React.FC = () => {
  const userData = useAppSelector(getVolumesUserState)

  const { data: baskets, isFetching } = useGetBaskets()

  const sharedBaskets =
    baskets?.filter((b) => b.userId !== userData.userId && b.isShared) ?? []

  return (
    <StyledMyPageBasketsSharedToYou>
      {isFetching ? (
        <Loader style={{ minHeight: '275px' }} />
      ) : (
        <MyPageSpecsBasketsGrid baskets={sharedBaskets} />
      )}
    </StyledMyPageBasketsSharedToYou>
  )
}
